import { Provider } from '@angular/core';

import { AccessService } from '@app/core/services/access.service';
import { ACCESS_STORE } from '@app/core/stores/access.store';
import { AccountService } from '@core/services/account.service';
import { AttributeFilteringService } from '@core/services/attribute-filtering.service';
import { AttributeSelectionService } from '@core/services/attribute-selection.service';
import { FilterSanitizationService } from '@core/services/filter-sanitization.service';
import { FilterSelectionService } from '@core/services/filter-selection.service';
import { InspectionAttributeAssignmentsSortingService } from '@core/services/inspection-attribute-assignments-sorting.service';
import { ItemAttributeAssignmentsSortingService } from '@core/services/item-attribute-assignments-sorting.service';
import { LopAttributeAssignmentsSortingService } from '@core/services/lop-attribute-assignments-sorting.service';
import { OnboardingService } from '@core/services/onboarding.service';
import { PermissionsService } from '@core/services/permissions.service';
import { SelectionFilterService } from '@core/services/selection-filter.service';
import { SortingService } from '@core/services/sorting.service';
import { UserStateService } from '@core/services/user-state.service';
import { UserService } from '@core/services/user.service';
import { ACCOUNT_STORE } from '@core/stores/account.store';
import { APP_STORE } from '@core/stores/app.store';
import { ATTRIBUTE_ASSIGNMENT_FILTERS_STORE } from '@core/stores/attribute-assignment-filters.store';
import { USER_STATE_STORE } from '@core/stores/user-state.store';
import { USER_STORE } from '@core/stores/user.store';

export const CORE_PROVIDERS: Provider[] = [
  AccessService,
  AccountService,
  AttributeFilteringService,
  AttributeSelectionService,
  FilterSanitizationService,
  FilterSelectionService,
  InspectionAttributeAssignmentsSortingService,
  ItemAttributeAssignmentsSortingService,
  LopAttributeAssignmentsSortingService,
  OnboardingService,
  PermissionsService,
  SelectionFilterService,
  SortingService,
  UserService,
  UserStateService,

  ACCESS_STORE,
  ACCOUNT_STORE,
  APP_STORE,
  ATTRIBUTE_ASSIGNMENT_FILTERS_STORE,
  USER_STATE_STORE,
  USER_STORE
];
